import "./src/logo.svg";
import "./src/address--colorful.svg";
import "./src/clock-colorful--circle--light.svg";
import "./src/rouble-colorful--circled--light.svg";
import "./src/gift--colorful.svg";


// WEBPACK FOOTER //
// ./application/components/dumb/icon/icons-sprite-themed.replaceable.js